import { L10n } from '@flippingbook/web.react-kit/dist/L10n';

import { loc } from '@/localization';

import warningIcon from './assets/warning.svg';
import { b, e } from './style.css';

const STATUS_PAGE_URL = 'https://status.flippingbook.com';

function stopEventPropagation(e: React.MouseEvent) {
    e.stopPropagation();
}

export function UnresolvedIncidents() {
    return (
        <div
            className={b.name}
            onClick={stopEventPropagation}
        >
            <img
                className={e.icon}
                src={warningIcon}
                alt={loc.Main.Warning}
            />
            <p className={e.description}>
                <L10n
                    text={loc.Main.HelpMenuUnresolvedIncidentsDescription}
                    replaces={[
                        [
                            '{0}',
                            <a
                                className={e.link}
                                href={STATUS_PAGE_URL}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {loc.Main.HelpMenuUnresolvedIncidentsStatusLink}
                            </a>,
                        ],
                    ]}
                />
            </p>
        </div>
    );
}
